const ON_CHANGE_DEBOUNCE_TIMER = 400; // Rozsądna wartość debounce (400ms)

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
